import React, { useEffect, useLayoutEffect } from 'react'
import { getUserIdentity } from '../common/helpers/authorizationHelper';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { getNavigationUrl } from '../common/helpers/navigationHelpers';

const useAdminCheck = () => {
    const navigate = useNavigate();
    const { firmname } = useParams();

    useLayoutEffect(() => {
        if (getUserIdentity() != "ADMIN") {
            navigate(getNavigationUrl("/dashboard"));
            toast.error("Bu sayfaya erişim yetkiniz bulunmamaktadır.");
        }
    }, []);
}

export default useAdminCheck